import { render } from "./AddTask.vue?vue&type=template&id=1f0c1a10&scoped=true"
import script from "./AddTask.vue?vue&type=script&lang=js"
export * from "./AddTask.vue?vue&type=script&lang=js"

import "./AddTask.vue?vue&type=style&index=0&id=1f0c1a10&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1f0c1a10"

export default script